import React from 'react';

import { VerificationRequestForReportItemFragment } from 'src/api';
import { HiddenResultsTable } from 'src/components/common';
import { useFilterStorage, useSearch } from 'src/hooks/common';
import {
  useVerificationRequestsReportList,
  useVerificationRequestsTableRowActions,
} from 'src/hooks/reports';

import { VERIFICATION_REQUESTS_TABLE_COLUMNS_EMPLOYER_STAFF } from '../constants';

export const VerificationRequestsTableEmployerManager: React.FC = () => {
  const { searchValue } = useSearch();
  const { pagination } = useFilterStorage();
  const rowActions = useVerificationRequestsTableRowActions();

  const { verificationRequestsCount, verificationRequests, loading } =
    useVerificationRequestsReportList({}, !searchValue);

  return (
    <HiddenResultsTable<VerificationRequestForReportItemFragment>
      columns={VERIFICATION_REQUESTS_TABLE_COLUMNS_EMPLOYER_STAFF}
      rowActions={rowActions}
      items={verificationRequests}
      itemsCount={verificationRequestsCount}
      pagination={pagination}
      loading={loading}
    />
  );
};
